import { TagTextAlert, TextExternalLink, Span } from "@bridgesplit/ui";
import { ERROR_CODES as PandoraErrorCodes } from "@loopscale/pandora-types";
import { getPandoraErrorCode, PandoraErrorCode, UnpublishedPandoraErrorCodes } from "@bridgesplit/abf-react";
import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query/fetchBaseQuery";

export function PandoraQuoteError({
    externalQuoteError,
    allSimulationFailed
}: {
    externalQuoteError: FetchBaseQueryError | SerializedError | undefined;
    allSimulationFailed?: boolean;
}) {
    const errorCode = getPandoraErrorCode(externalQuoteError);
    const { preLinkText, linkUrl, linkText } = getErrorHelpInfo(errorCode, allSimulationFailed);

    return (
        <TagTextAlert color="error" icon="warning">
            <Span>
                {preLinkText}
                <TextExternalLink
                    href={linkUrl}
                    sx={{ color: "secondary.main", display: "inline" }}
                    isPrimary
                    underlineLink
                >
                    {linkText}
                </TextExternalLink>
            </Span>
        </TagTextAlert>
    );
}

interface MappedErrorInfo {
    preLinkText: string;
    linkUrl: string;
    linkText: string;
}

function getErrorHelpInfo(
    errorCode: PandoraErrorCode | undefined,
    allSimulationFailed: boolean | undefined
): MappedErrorInfo {
    if (allSimulationFailed) {
        return {
            preLinkText: "Unable to simulate transactions. Please try again later or ",
            linkUrl: "https://docs.loopscale.com/using-loopscale/loop#manually-close",
            linkText: "manually manage your position."
        };
    }
    switch (errorCode) {
        case UnpublishedPandoraErrorCodes.NO_QUOTE_AVAILABLE:
            return {
                preLinkText: "Not enough liquidity to swap this position size right now. Try a smaller amount or ",
                linkUrl: "https://docs.loopscale.com/using-loopscale/loop#manually-close",
                linkText: "manually manage your position."
            };
        case PandoraErrorCodes.JUPITER_NO_ROUTES_FOUND:
        default:
            return {
                preLinkText:
                    "Unable to find a swap route through our integration partners. Please check back later or ",
                linkUrl: "https://docs.loopscale.com/using-loopscale/loop#manually-close",
                linkText: "manually manage your position."
            };
    }
}
